const PATH = 'fe.pages.organization.subscriptions.subscription_card';

const messages = {
  expiresOn: {
    key: `${PATH}.expires_on`,
    defaultValue: 'Expires On'
  },
  educatorSubscriptions: {
    key: `${PATH}.educator_subscriptions`,
    defaultValue: 'Educator Subscriptions'
  },
  available: {
    key: `${PATH}.available`,
    defaultValue: 'Available'
  },
  used: {
    key: `${PATH}.used`,
    defaultValue: 'Used'
  },
  total: {
    key: `${PATH}.total`,
    defaultValue: 'Total'
  },
  classrooms: {
    key: `${PATH}.classrooms`,
    defaultValue: 'Classrooms'
  },
  seats: {
    key: `${PATH}.seats`,
    defaultValue: 'Seats'
  }
};

export default messages;
